module.exports = __webpack_public_path__ + "static/kenku-monk-whey-shu-AYAGWW-1836f7ca70ad35ca08c4220ad25115b0.png";